import React, { useEffect, useState } from 'react';
import './StoreAvailabilityStatus.scss';
import StoreAvailabilityInStock from './../../../../../../../../static/assets/svg/store-availability-in-stock.svg';
import StoreAvailabilityStockLow from './../../../../../../../../static/assets/svg/store-availability-stock-low.svg';
import StoreAvailabilityOutOfStock from './../../../../../../../../static/assets/svg/store-availability-out-of-stock.svg';

function StoreAvailabilityStatus({ status, title }) {
  const [statusIcon, setStatusIcon] = useState(null);

  useEffect(() => {
    if (status) {
      if (status === 'inStock') {
        setStatusIcon(StoreAvailabilityInStock);
      } else if (status === 'stockLow') {
        setStatusIcon(StoreAvailabilityStockLow);
      } else if (status === 'outOfStock') {
        setStatusIcon(StoreAvailabilityOutOfStock);
      }
    }
  }, [status]);

  return (
    <div className="store-status">
      {statusIcon && <img alt="status" src={statusIcon} />}
      {title && <div className="store-status__title od-font-reg">{title}</div>}
    </div>
  );
}

export default StoreAvailabilityStatus;
